// «Иконка Агапеллы всё равно прыгает по экрану» на мобильном вебе при
// прокрутке — даже после the first attempt at this (debouncing the height by
// 300 ms: useSettledValue, removed). Owner, 12.10.2026: «сделай как на
// нативке».
//
// Native uses the exact same geometry (useWidgetDrag is shared — see its own
// comment) and never jumps, not because its code treats height differently,
// but because its `height` never moves on its own: there is no browser
// address bar to hide and show. RN Web's `useWindowDimensions()` tracks
// `window.visualViewport.height` instead (chosen there deliberately, for
// keyboard reactivity — see Dimensions' own comment), and on Android/iOS
// Chrome THAT number shrinks while the bar is showing and grows the moment it
// auto-hides on scroll.
//
// Debouncing that number still ends in one visible correction once scrolling
// settles — which reads as a jump just as much, only a rarer one. Matching
// native for real means the resting position must not react to the bar at
// all: a genuine resize or rotation changes WIDTH at the same moment (see
// `nextStableHeight`), so only that is treated as a reason to resample
// height; a height-only wobble is simply never looked at again until it does.
import { useRef } from 'react';

import { nextStableHeight } from './stableHeight';

/** `height`, pinned to whatever it was the last time `width` actually
 *  changed — not to its own live value. */
export function useStableHeight(width: number, height: number): number {
  const memo = useRef({ width, height });
  memo.current = nextStableHeight(memo.current, width, height);
  return memo.current.height;
}
